<script setup>
import { computed, provide, reactive } from "vue";
import { useRoute, RouterView } from "vue-router";

const route = useRoute();
const layout = computed(() => {
    if (route.name) {
        return (route.meta.layout || "app") + "-layout";
    }
});

const globalRefs = reactive({});

provide("globalRefs", globalRefs);
</script>

<template>
    <div class="font-base z-[99999] w-screen h-screen overflow-auto fixed inset-0 font-sans text-black bg-white dark:text-white dark:bg-gray-950">
        <div id="nprogress-container" class="z-[100001] sticky top-0"></div>
        <div id="datepicker-container"></div>
        <component v-if="layout" :is="layout">
            <RouterView />
        </component>
    </div>
</template>

<style lang="css">
.otomatic-ai-app #nprogress {
    --nprogress-color: var(--color-gray-900);
}
</style>
